import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";

const getDocument = (data: any)  => {
	const authenticity_token = getCookie(cookieToken);
	const apiEndpoint = data?.documentType === "common"
		? api.documents.commonDocument
		: api.documents.document;

	const endpoint = apiEndpoint
		.replace('{locale}', `${data.locale}`)
		.replace('{type}', `${data.type}`);

	return fetch(
		`${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : null}`,
		{...RequestOptions('GET')}
	)
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
};

export const documentsService = {
	getDocument
};
